export enum EInterventionStatus {
  Assignment = 'assignment',
  AwaitingInvoice = 'awaiting_invoice',
  AwaitingQuote = 'awaiting_quote',
  AwaitingReport = 'awaiting_report',
  AwaitingVisitDate = 'awaiting_visit_date',
  AwaitingWorkDates = 'awaiting_work_dates',
  Complaint = 'complaint',
  InvoiceReceived = 'invoice_received',
  Lost = 'lost',
  QualitySurvey = 'quality_survey',
  QuoteReceived = 'quote_received',
  ReportReceived = 'report_received',
  Success = 'success',
  Trashed = 'trashed',
  VisitPlanned = 'visit_planned',
  WorkOngoing = 'work_ongoing',
  WorkPlanned = 'work_planned',
}

export enum EInterventionVatType {
  SixPercent = 'six_percent',
  TwelvePercent = 'twelve_percent',
  TwentyOnePercent = 'twenty_one_percent',
}
